import {
    getAllData,
    postData
} from '@/store/api/method'
const basepath = 'internship-exam-chat'
const initialState = () => ({
    list: [],
    msg: 'Jaringan Bermasalah',
    status: 0
})
const state = initialState
const getters = {
    getList: state => state.list || [],
    getMsg: state => state.msg,
    getStatus: state => state.status
}

const actions = {
    async fetchData({
        commit
    }, url) {
        try {
            const response = await getAllData(`${basepath}/${url}`);
            commit('SET_LIST', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async submit({
        commit
    }, {url, message}) {
        try {
            const response = await postData(`${basepath}/${url}`,{message});
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MSG(state, error) {
        if(error.status == 400){
            state.msg = error.data.msg
            state.status = error.data.status
        }else{
            state.msg = 'Mohon Periksa Kembali'
            state.status = 0
        }
    },
    SET_LIST(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.list = response.data
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}